
import { useNavigate } from "react-router-dom";

export function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t py-8">
      <div className="container text-center text-sm text-muted-foreground">
        <p>© {currentYear} Hour Tracker. All rights reserved.</p>
        <div className="flex justify-center gap-4 mt-2">
          <a href="#" onClick={(e) => {e.preventDefault(); navigate("/privacy-terms")}} className="hover:underline">
            Privacy Policy & Terms of Service
          </a>
          <a href="#" onClick={(e) => {e.preventDefault(); navigate("/contact")}} className="hover:underline">
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
